import { GraphQLClient } from 'graphql-request'
import * as Dom from 'graphql-request/dist/types.dom'
import gql from 'graphql-tag'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  AWSDate: any
  AWSDateTime: any
  AWSEmail: string
  AWSIPAddress: any
  AWSJSON: any
  AWSPhone: any
  AWSTime: any
  AWSTimestamp: any
  AWSURL: string
  BigInt: any
  Double: any
}

export type Authentication = {
  __typename?: 'Authentication'
  providers: Array<ExternalIdProvider>
}

export enum ExternalIdProvider {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
}

export type LinkAccountInput = {
  provider: ExternalIdProvider
  userId: Scalars['String']
}

export type LinkAccountOutput = {
  __typename?: 'LinkAccountOutput'
  userId?: Maybe<Scalars['String']>
}

export type Mutation = {
  __typename?: 'Mutation'
  linkAccount: LinkAccountOutput
  unlinkAccount: UnlinkOutput
}

export type MutationLinkAccountArgs = {
  input: LinkAccountInput
}

export type MutationUnlinkAccountArgs = {
  input: UnlinkInput
}

export type Myself = {
  __typename?: 'Myself'
  authentication: Authentication
}

export type Query = {
  __typename?: 'Query'
  authentication: Authentication
}

export type UnlinkInput = {
  provider: ExternalIdProvider
}

export type UnlinkOutput = {
  __typename?: 'UnlinkOutput'
  provider: ExternalIdProvider
}

export type AuthenticationQueryVariables = Exact<{ [key: string]: never }>

export type AuthenticationQuery = {
  __typename?: 'Query'
  authentication: {
    __typename?: 'Authentication'
    providers: Array<ExternalIdProvider>
  }
}

export type LinkAccountMutationVariables = Exact<{
  input: LinkAccountInput
}>

export type LinkAccountMutation = {
  __typename?: 'Mutation'
  linkAccount: {
    __typename?: 'LinkAccountOutput'
    userId?: string | null | undefined
  }
}

export type UnlinkAccountMutationVariables = Exact<{
  input: UnlinkInput
}>

export type UnlinkAccountMutation = {
  __typename?: 'Mutation'
  unlinkAccount: { __typename?: 'UnlinkOutput'; provider: ExternalIdProvider }
}

export const AuthenticationDocument = gql`
  query Authentication {
    authentication {
      providers
    }
  }
`
export const LinkAccountDocument = gql`
  mutation LinkAccount($input: LinkAccountInput!) {
    linkAccount(input: $input) {
      userId
    }
  }
`
export const UnlinkAccountDocument = gql`
  mutation UnlinkAccount($input: UnlinkInput!) {
    unlinkAccount(input: $input) {
      provider
    }
  }
`

export type SdkFunctionWrapper = <T>(
  action: (requestHeaders?: Record<string, string>) => Promise<T>,
  operationName: string,
) => Promise<T>

const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action()

export function getSdk(
  client: GraphQLClient,
  withWrapper: SdkFunctionWrapper = defaultWrapper,
) {
  return {
    Authentication(
      variables?: AuthenticationQueryVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<AuthenticationQuery> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<AuthenticationQuery>(
            AuthenticationDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'Authentication',
      )
    },
    LinkAccount(
      variables: LinkAccountMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<LinkAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<LinkAccountMutation>(LinkAccountDocument, variables, {
            ...requestHeaders,
            ...wrappedRequestHeaders,
          }),
        'LinkAccount',
      )
    },
    UnlinkAccount(
      variables: UnlinkAccountMutationVariables,
      requestHeaders?: Dom.RequestInit['headers'],
    ): Promise<UnlinkAccountMutation> {
      return withWrapper(
        (wrappedRequestHeaders) =>
          client.request<UnlinkAccountMutation>(
            UnlinkAccountDocument,
            variables,
            { ...requestHeaders, ...wrappedRequestHeaders },
          ),
        'UnlinkAccount',
      )
    },
  }
}
export type Sdk = ReturnType<typeof getSdk>
